import React from 'react'
import Tooltip from '../Tooltip'
import { Container, Header, IconAll, IconBad, IconGood, IconMaybe } from './theme'

const PhotosFiltering = ({ selected = 'all', select }) => (
  <Container>
    <Header>Filtruj zdjęcia po:</Header>
    <Tooltip placement={'bottom'} title={'Wszystkie'}>
      <IconAll isSelected={selected === 'all'} onClick={() => select('all')} />
    </Tooltip>
    <Tooltip placement={'bottom'} title={'Zgodne'}>
      <IconGood isSelected={selected === 'good'} onClick={() => select('good')} />
    </Tooltip>
    <Tooltip placement={'bottom'} title={'Możliwe'}>
      <IconMaybe isSelected={selected === 'maybe'} onClick={() => select('maybe')} />
    </Tooltip>
    <Tooltip placement={'bottom'} title={'Niezgodne'}>
      <IconBad isSelected={selected === 'bad'} onClick={() => select('bad')} />
    </Tooltip>
  </Container>
)

export default PhotosFiltering



// WEBPACK FOOTER //
// ./src/components/PhotosFiltering/index.js